/**
 * React Query hook for external entity data
 */
import { useQuery } from '@tanstack/react-query';
import { getExternalEntities } from './ExternalEntityService';
/**
 * Hook to fetch external entities from a configurable URL with field mapping
 * @param url - The API endpoint URL to fetch entities from
 * @param fieldMapping - Field mapping configuration for id and name fields
 * @returns Query result with external entities data, loading state, and error
 */
export default function useGetExternalEntities(url, fieldMapping = { idField: 'value', nameField: 'label' }) {
    return useQuery({
        queryKey: ['external-entities', url, fieldMapping.idField, fieldMapping.nameField],
        queryFn: () => getExternalEntities(url, fieldMapping),
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 3,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
        enabled: !!url // Only run query if URL is provided
    });
}
